import { render } from "./SmartTaskEstimateDialog.vue?vue&type=template&id=379f9707&scoped=true"
import script from "./SmartTaskEstimateDialog.vue?vue&type=script&lang=js"
export * from "./SmartTaskEstimateDialog.vue?vue&type=script&lang=js"

import "./SmartTaskEstimateDialog.vue?vue&type=style&index=0&id=379f9707&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379f9707"]])

export default __exports__